const ar = {
  language: {
    label: "اللغة",
    english: "الإنجليزية",
    arabic: "العربية",
  },
  shell: {
    educationOs: "نظام التعليم",
    welcome: "مرحباً، {name}",
    logout: "تسجيل الخروج",
    navigation: "التنقل",
  },
  login: {
    signIn: "تسجيل الدخول",
    access: "ادخل إلى لوحة التحكم كموظف أو ولي أمر",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    submit: "تسجيل الدخول",
    submitting: "جارٍ تسجيل الدخول…",
    demos: "جرّب حساباً تجريبياً",
    demoPassword: "كلمة المرور لجميع الحسابات التجريبية:",
    welcome: "مرحباً بك في EduOS",
    platformBadge: "عمليات المدرسة، متصلة",
    emailPlaceholder: "you@school.ae",
    heroLead: "منصة واحدة من أجل",
    heroAccent: "رحلة الطالب المتكاملة.",
    heroDescription: "من القبول في الحضانة إلى التخرج — القبول والرسوم والحضور والتواصل مع أولياء الأمور ضمن منظومة واحدة قابلة للإعداد.",
    admissionFeature: "من القبول إلى التسجيل",
    admissionFeatureDetail: "مسار متكامل",
    recordsFeature: "سجل الطالب الشامل",
    recordsFeatureDetail: "نظام الطلاب وأولياء الأمور",
    feesFeature: "الرسوم ودفتر الحسابات",
    feesFeatureDetail: "فواتير موثوقة",
    circularsFeature: "تعاميم أولياء الأمور",
    circularsFeatureDetail: "البريد الإلكتروني وإيصالات القراءة",
    trustFooter: "عزل بيانات كل مدرسة · محاسبة دقيقة · سجل تدقيق لكل عملية",
  },
  account: {
    title: "حساب EduOS الخاص بك",
    signedInAs: "تم تسجيل دخولك باسم {name}.",
    recognizedRoles: "الأدوار المعروفة",
    permissionNotice: "يتم تعيين صلاحيات الوحدات بشكل منفصل. تواصل مع مالك الحضانة إذا كنت بحاجة إلى الوصول إلى سير عمل.",
  },
  calendar: {
    previousMonth: "الشهر السابق",
    nextMonth: "الشهر التالي",
    previousYear: "السنة السابقة",
    nextYear: "السنة التالية",
    previousYears: "سنوات سابقة",
    nextYears: "سنوات لاحقة",
    chooseMonth: "اختر الشهر",
    chooseYear: "اختر السنة",
  },
  common: {
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    save: "حفظ",
    edit: "تعديل",
    delete: "حذف",
    view: "عرض",
    download: "تنزيل",
    close: "إغلاق",
  },
  passwordChange: { title: "تعيين كلمة المرور", subtitle: "استبدل كلمة المرور المؤقتة قبل المتابعة.", current: "كلمة المرور المؤقتة الحالية", new: "كلمة المرور الجديدة", confirm: "تأكيد كلمة المرور الجديدة", guidance: "12 حرفاً على الأقل مع أحرف كبيرة وصغيرة ورقم ورمز.", submit: "تحديث كلمة المرور" },
  admissions: {
    selectSectionTitle: "اختر القسم",
    selectSectionDescription: "اختر قسماً لديه سعة متاحة قبل تسجيل الطفل.",
    section: "القسم",
    chooseSection: "اختر قسماً",
    enroll: "تسجيل",
    enrollSetsStatus: "ينشئ التسجيل سجل الطالب ويغيّر حالة الطلب إلى «مسجل».",
  },
  admissionWizard: {
    title: "طلب قبول جديد",
    newDraft: "بدء طلب عائلي آمن",
    savedDraft: "مسودة محفوظة — التغييرات مشتركة مع فريق القبول",
    notDraft: "لم يعد من الممكن تعديل هذا الطلب كمسودة.",
    back: "العودة إلى القبول",
    progress: "تقدم الطلب",
    saveExit: "حفظ وخروج",
    saveContinue: "حفظ ومتابعة",
    previous: "السابق",
    submit: "إرسال الطلب",
    draftSaved: "تم حفظ المسودة",
    draftCount: "{count} مسودات محفوظة",
    noDrafts: "لا توجد مسودات محفوظة.",
    untitled: "بدون عنوان",
    familyPending: "بيانات الأسرة غير مكتملة",
    loading: "جارٍ تحميل إعدادات الطلب…",
    loadError: "تعذر تحميل إعدادات الطلب.",
    retry: "إعادة المحاولة",
    submitted: "تم إرسال الطلب {number}",
    steps: { child: "الطفل", parents: "الوالدان", documents: "المستندات", review: "المراجعة" },
    people: { child: "الطفل", father: "الأب", mother: "الأم" },
    child: { title: "الطفل والتسجيل", description: "أضف هوية الطفل وعنوانه والصف والسنة الدراسية المطلوبة." },
    parents: {
      title: "الوالدان وجهات الاتصال",
      description: "سجّل بيانات منفصلة للأب والأم واختر جهات اتصال الأسرة.",
      primary: "جهة الاتصال الأساسية",
      makePrimary: "تعيين كجهة الاتصال الأساسية",
      emergency: "جهة اتصال للطوارئ",
    },
    fields: {
      firstName: "الاسم الأول", lastName: "اسم العائلة", fullName: "الاسم الكامل", dob: "تاريخ الميلاد",
      birthPlace: "مكان الميلاد", gender: "الجنس", nationality: "الجنسية", grade: "الصف",
      year: "السنة الدراسية", street: "عنوان الشارع", apartment: "الشقة / الوحدة", email: "البريد الإلكتروني",
      phone: "الهاتف", education: "المستوى التعليمي", occupation: "المهنة", workplace: "مكان العمل",
      workDetails: "تفاصيل العمل", select: "اختر",
    },
    documents: {
      title: "مستندات الأسرة",
      description: "ارفع نسخ جوازات السفر للطفل والأب والأم. الهوية الإماراتية والتأشيرة اختياريتان ويمكن تقديمهما إذا كانتا متاحتين أو منطبقتين.",
      required: "مطلوب قبل الإرسال", optional: "اختياري", optionalIfApplicable: "اختياري — يُقدّم إذا كان متاحاً أو منطبقاً",
      number: "رقم المستند", expiry: "تاريخ الانتهاء", upload: "رفع الملفات", uploading: "جارٍ الرفع…",
    },
    review: {
      title: "المراجعة والإرسال", description: "تحقق من بيانات الأسرة واكتمال المستندات قبل إدخال الطلب في مسار القبول.",
      documents: "المستندات المطلوبة {count}", missing: "أكمل العناصر التالية", privacy: "تُحفظ ملفات الهوية كمستندات حساسة ولا تتوفر إلا من خلال وصول مصرح به للملف الشخصي أو الطلب.",
    },
  },
  guardianActivation: {
    title: "تفعيل حساب ولي الأمر",
    description: "عيّن كلمة مرور مؤقتة لـ {name}. يجب استبدالها عند تسجيل الدخول لأول مرة.",
    password: "كلمة المرور المؤقتة",
    activate: "تفعيل الحساب",
    active: "نشط",
    inactive: "غير نشط",
    documents: "{count} مستندات هوية",
    success: "تم تفعيل حساب ولي الأمر",
  },
  forbidden: {
    title: "الوصول مقيّد",
    message: "لا يملك دورك صلاحية استخدام سير العمل هذا.",
    back: "العودة",
  },
  roles: {
    platform_admin: "مسؤول المنصة",
    tenant_owner: "المالك",
    administrator: "المسؤول",
    principal: "المدير",
    accountant: "المحاسب",
    teacher: "المعلم",
    guardian: "ولي الأمر",
  },
  nav: {
    inventory: "المخزون والمستلزمات",
    dashboard: "لوحة التحكم",
    admissions: "القبول",
    students: "الطلبة",
    attendance: "الحضور",
    timetable: "الجدول الزمني",
    exams: "الامتحانات",
    library: "المكتبة",
    services: "الخدمات",
    announcements: "الإعلانات",
    erp: "نظام موارد المؤسسة",
    campus: "الحرم الجامعي",
    nursery: "الحضانة / EYFS",
    fees: "الرسوم",
    circulars: "النشرات",
    academicSetup: "الإعداد الأكاديمي",
    staff: "الموظفون",
    dcuments: "المستندات",
    institution: "المؤسسة",
    platformSettings: "إعدادات المنصة",
    branding: "الهوية البصرية",
    platformConfiguration: "إعدادات المنصة",
    platformLookups: "قوائم المنصة",
    reports: "التقارير",
    kiosk: "جهاز تسجيل الدخول",
    home: "الرئيسية",
    homework: "الواجبات",
    marks: "الدرجات",
    study: "الدراسة",
    gallery: "صور الأنشطة",
    account: "الحساب",
  },
  inventory: {
    title: "المخزون والمستلزمات",
    subtitle: "حافظ على مستلزمات الصفوف واضحة ومُسعّرة وجاهزة ليوم دراسي جديد.",
    managementLabel: "إدارة المخزون",
    summary: "ملخص المخزون",
    totalItems: "عناصر الكتالوج",
    activeItems: "سجلات المخزون النشطة",
    availableUnits: "الوحدات المتاحة",
    currentBalance: "الرصيد الحالي",
    lowStock: "مخزون منخفض",
    needsAttention: "يتطلب الانتباه",
    catalogueValue: "قيمة الكتالوج",
    availableValue: "قيمة المخزون المتاح",
    catalogueTitle: "كتالوج مستويات المخزون",
    catalogueDescription: "ابحث عن المستلزمات المتاحة في الحضانة وراجعها وأدرها.",
    lowStockCount: "{count} عناصر تتطلب الانتباه",
    searchPlaceholder: "البحث بالعنصر أو الرمز أو الفئة…",
    allCategories: "كل الفئات",
    allStatuses: "كل الحالات",
    healthyStock: "مخزون جيد",
    item: "العنصر",
    category: "الفئة",
    available: "المتاح",
    unitPrice: "سعر الوحدة (درهم)",
    target: "الهدف",
    targetStock: "المخزون المستهدف",
    alertPercent: "تنبيه انخفاض المخزون (%)",
    defaultAlert: "استخدام الإعداد الافتراضي",
    status: "الحالة",
    actions: "الإجراءات",
    low: "منخفض",
    healthy: "جيد",
    archive: "أرشفة",
    showing: "عرض {shown} من أصل {total} عناصر",
    priceNote: "الأسعار معروضة بالدرهم الإماراتي",
    loading: "جارٍ تحميل كتالوج المخزون…",
    empty: "لا توجد عناصر مخزون بعد",
    emptyDescription: "أضف أول مستلزم صفي لبدء بناء الكتالوج.",
    noMatches: "لا توجد عناصر مخزون مطابقة",
    noMatchesDescription: "جرّب مصطلح بحث مختلفاً أو امسح عوامل التصفية.",
    clearFilters: "مسح عوامل التصفية",
    managementOnly: "كتالوج المخزون متاح لمستخدمي الإدارة فقط.",
    addStock: "إضافة مخزون",
    addTitle: "إضافة عنصر مخزون",
    addDescription: "أنشئ عنصراً بالوحدة والمستوى المستهدف وسعره بالدرهم الإماراتي.",
    editTitle: "تعديل عنصر المخزون",
    editDescription: "حدّث تفاصيل الكتالوج وإعدادات انخفاض المخزون مع الحفاظ على السجل التاريخي.",
    itemName: "اسم العنصر",
    itemNamePlaceholder: "مثال: قلم سبورة — أزرق",
    sku: "رمز الصنف",
    unit: "الوحدة",
    selectCategory: "اختر الفئة",
    selectUnit: "اختر الوحدة",
    priceHelp: "يُدخل السعر بالدرهم ويُحفظ بوحدات العملة الصغرى.",
    saveChanges: "حفظ التغييرات",
    addSuccess: "تمت إضافة عنصر المخزون",
    editSuccess: "تم تحديث عنصر المخزون",
    archiveSuccess: "تمت أرشفة عنصر المخزون",
    archiveTitle: "هل تريد أرشفة عنصر المخزون؟",
    archiveDescription: "سيُزال {item} من عروض الكتالوج النشطة، مع بقاء سجل المخزون السابق.",
  },
  dashboard: {
    title: "لوحة التحكم",
    attendanceToday: "الحضور اليوم",
    attendanceSummary: "{present} حاضر · {absent} غائب · {unmarked} دون تسجيل",
    collectionsToday: "التحصيل اليوم",
    mtd: "منذ بداية الشهر",
    outstanding: "المستحقات",
    pendingInvoices: "الفواتير المعلقة",
    totalStudents: "إجمالي الطلبة",
    enrolled: "المسجلون",
    admissionsFunnel: "مسار القبول",
    newToday: "{count} جديد اليوم",
    noApplications: "لا توجد طلبات حتى الآن.",
    quickActions: "إجراءات سريعة",
    reviewApplications: "مراجعة الطلبات",
    composeCircular: "إنشاء نشرة",
    generateInvoices: "إنشاء الفواتير",
    viewStudents: "عرض الطلبة",
    loadError: "تعذر تحميل لوحة التحكم.",
    alerts: {
      attendanceBelow: "الحضور أقل من 80٪ اليوم ({percentage}٪)",
      outstandingThreshold: "تتجاوز المستحقات {amount}",
      unmarkedSections: "لم يسجل الحضور في {count} من أصل {total} أقسام اليوم",
    },
    funnel: {
      enquiry: "استفسار",
      applied: "تم التقديم",
      documents_pending: "المستندات معلقة",
      shortlisted: "القائمة المختصرة",
      interview_scheduled: "تم تحديد المقابلة",
      offered: "تم تقديم العرض",
      fee_paid: "تم دفع الرسوم",
      enrolled: "مسجل",
    },
  },
  guardian: {
    today: "اليوم",
    yourChild: "طفلك",
    yourWards: "أبناؤك {count}",
    present: "حاضر",
    absent: "غائب",
    late: "متأخر",
    half_day: "نصف يوم",
    excused: "بعذر",
    notMarked: "لم يسجل",
    attendance30d: "الحضور خلال 30 يوماً",
    dues: "المستحقات",
    feesDue: "الرسوم المستحقة",
    view: "عرض",
    viewAll: "عرض الكل",
    allCaughtUp: "لا توجد مستحقات حالياً.",
    acrossInvoices: "عبر {count} فاتورة",
    unreadCirculars: "النشرات غير المقروءة",
    noNewCirculars: "لا توجد نشرات جديدة.",
    noWards: "لا توجد أبناء مرتبطون بحسابك بعد.",
    feesTitle: "الرسوم",
    feesSubtitle: "جميع فواتير أبنائك",
    totalOutstanding: "إجمالي المستحقات",
    unpaidOfTotal: "{unpaid} غير مدفوعة · {total} الإجمالي",
    dueOn: "تاريخ الاستحقاق {date}",
    total: "الإجمالي",
    paid: "المدفوع",
    balance: "الرصيد",
    payOnline: "الدفع عبر الإنترنت",
    startingPayment: "جارٍ بدء الدفع…",
    invoicePdf: "فاتورة PDF",
    paymentHistory: "سجل المدفوعات",
    loading: "جارٍ التحميل…",
    noPaymentsYet: "لا توجد مدفوعات مسجلة بعد.",
    date: "التاريخ",
    receipt: "الإيصال",
    method: "الطريقة",
    amount: "المبلغ",
    status: "الحالة",
    action: "الإجراء",
    noInvoicesYet: "لا توجد فواتير بعد.",
    studyTitle: "الدراسة",
    studySubtitle: "الواجبات والامتحانات وبيانات التقارير",
    homework: "الواجبات",
    exams: "الامتحانات",
    reportCards: "بيانات التقارير",
    submitted: "تم التسليم",
    noHomeworkYet: "لا توجد واجبات بعد.",
    graded: "تم التصحيح",
    yourSubmission: "إجابتك",
    submissionPlaceholder: "اكتب أو الصق عملك",
    submit: "تسليم",
    submitting: "جارٍ التسليم...",
    upcomingExams: "الامتحانات القادمة / الأخيرة",
    marks: "الدرجات",
    noMarksYet: "لم تنشر الدرجات بعد.",
    reportCardTitle: "بيان التقرير · {exam}",
    overallGrade: "التقدير العام",
    percentage: "النسبة المئوية",
    subject: "المادة",
    grade: "التقدير",
    teacherRemark: "ملاحظة معلم الفصل",
    noReportCardsYet: "لا توجد بيانات تقارير بعد.",
    servicesTitle: "الخدمات",
    servicesSubtitle: "الحافلات والفعاليات والوجبات",
    bus: "الحافلة",
    events: "الفعاليات",
    meals: "الوجبات",
    noBusAssigned: "لم يتم تعيين حافلة بعد.",
    assignedRoute: "المسار المعين",
    driver: "السائق",
    conductor: "المشرف",
    routeStops: "محطات المسار",
    pickup: "صعود",
    drop: "نزول",
    pickupDropAt: "صعود {pickup} · نزول {drop}",
    yes: "نعم",
    no: "لا",
    rsvpSaved: "تم حفظ التأكيد",
    noUpcomingEvents: "لا توجد فعاليات قادمة.",
    weekOf: "أسبوع {date}",
    breakfast: "الفطور:",
    lunch: "الغداء:",
    snacks: "الوجبات الخفيفة:",
    noMenuPublished: "لم يتم نشر قائمة الوجبات.",
    day0: "الاثنين",
    day1: "الثلاثاء",
    day2: "الأربعاء",
    day3: "الخميس",
    day4: "الجمعة",
    day5: "السبت",
    day6: "الأحد",
    activityPhotosTitle: "صور وفيديو الأنشطة",
    activityPhotosSubtitle: "أعد تجربة يوم طفلك في المدرسة — الصور والفيديو من الفصل والفعاليات",
    activityPhotosHero: "لحظات طفلك، ملتقطة ومشاركة",
    activityPhotosEmpty: "لا توجد ألبومات بعد. عندما يشارك المعلمون صوراً جديدة، ستظهر هنا.",
    activityPhotosRecent: "أحدث الأنشطة",
    activityPhotosViewAll: "فتح المعرض",
    albumsCount: "{count} ألبومات",
    mediaItemsCount: "{count} وسائط",
    gallerySearchPlaceholder: "ابحث في الألبومات…",
    galleryConsentTitle: "إعدادات مشاركة الصور",
    galleryConsentHint: "تحكم في إمكانية مشاركة صور طفلك معك. يمكنك تغيير ذلك في أي وقت.",
    galleryConsentUpdated: "تم تحديث تفضيل مشاركة الصور",
    galleryConsentOn: "الصور ظاهرة لك",
    galleryConsentOff: "الصور متوقفة لهذا الطفل",
    galleryNoSearchResults: "لا توجد ألبومات تطابق بحثك.",
    galleryNoMediaInAlbum: "لا توجد صور أو فيديوهات في هذا الألبوم بعد.",
    galleryLightbox: "عارض الصور",
    mediaCount: "{count} صور وفيديو",
    circularsTitle: "النشرات",
    circularsSubtitle: "إعلانات وإشعارات المدرسة",
    noCircularsYet: "لا توجد نشرات بعد.",
    paymentNoPending: "لا توجد عملية دفع معلقة لإكمالها.",
    backToFees: "العودة إلى الرسوم",
    securePaymentSim: "دفع آمن (محاكاة)",
    hostedCheckout: "صفحة الدفع المستضافة من Network International",
    card: "البطاقة",
    cancel: "إلغاء",
    fail: "فشل",
    payNow: "ادفع الآن",
    paymentSuccessful: "تم الدفع بنجاح",
    paymentCancelled: "تم إلغاء الدفع",
    paymentFailed: "فشل الدفع",
    statuses: {
      active: "نشط",
      enrolled: "مسجل",
      inactive: "غير نشط",
      withdrawn: "منسحب",
      transferred: "منقول",
      issued: "صادرة",
      partially_paid: "مدفوعة جزئياً",
      overdue: "متأخرة",
      paid: "مدفوعة",
      voided: "ملغاة",
      refunded: "مستردة",
      success: "ناجحة",
      failed: "فاشلة",
      cancelled: "ملغاة",
      initiated: "بدأت",
    },
    methods: {
      online: "عبر الإنترنت",
      cash: "نقداً",
      bank_transfer: "تحويل مصرفي",
      pos: "نقطة بيع",
      cheque: "شيك",
      neft: "NEFT",
    },
  },
  teacher: {
    greeting: "مرحباً، {name}",
    yourSections: "أقسامك",
    gradeSection: "{grade} · الشعبة {name}",
    studentsCount: "{count} طلاب",
    attendancePending: "الحضور غير مسجل",
    noSectionsAssigned: "لا توجد أقسام مسندة.",
    latestCirculars: "أحدث التعاميم",
    markAttendance: "تسجيل الحضور",
    tapOnceSubtitle: "انقر مرة واحدة للتسجيل أو استخدم الإجراءات الجماعية",
    section: "الشعبة",
    chooseSection: "اختر شعبة",
    date: "التاريخ",
    lockedWarning: "الحضور لهذا التاريخ مقفل",
    allLabel: "الجميع {label} ({count})",
    present: "حاضر",
    absent: "غائب",
    late: "متأخر",
    markAria: "تسجيل {label}",
    emptySelectSection: "اختر شعبة لتسجيل الحضور",
    saveMarked: "حفظ · تم تسجيل {marked}/{total}",
    saving: "جارٍ الحفظ...",
    attendanceMarkedToast: "تم تسجيل حضور {count} طالباً",
    homeworkTitle: "الواجبات",
    homeworkSubtitle: "انشر الواجبات وراجع التسليمات",
    new: "جديد",
    postHomework: "نشر واجب",
    subject: "المادة",
    title: "العنوان",
    instructions: "التعليمات",
    dueDate: "تاريخ الاستحقاق",
    maxMarks: "الدرجة العظمى",
    posting: "جارٍ النشر...",
    dueOn: "يستحق في {date}",
    noHomeworkYet: "لا توجد واجبات بعد.",
    submissionsCount: "التسليمات ({count})",
    noSubmissionsYet: "لا توجد تسليمات بعد.",
    submittedOn: "سُلّم في {date}",
    graded: "مُقيّم",
    marksPlaceholder: "الدرجة (الحد {max})",
    feedback: "ملاحظات",
    saveGrade: "حفظ الدرجة",
    gradedToast: "تم التقييم",
    homeworkPostedToast: "تم نشر الواجب",
    marksEntry: "إدخال الدرجات",
    marksSubtitle: "أدخل درجات الاختبار لكل مادة",
    exam: "الاختبار",
    chooseExam: "اختر اختباراً",
    marksLockedWarning: "درجات هذه المادة مقفلة",
    pickExamEmpty: "اختر اختباراً ومادة لإدخال الدرجات",
    absentCheckbox: "غائب",
    saveMarksFor: "حفظ درجات {count} طالباً",
    savedEntriesToast: "تم حفظ {count} سجلات",
  },
  staffCirculars: {
    title: "التعاميم",
    close: "إغلاق",
    subtitle: "إعلانات وإشعارات على مستوى المدرسة",
    newCircular: "تعميم جديد",
     newEmergency: "إعلان طارئ جديد",
    composeCircular: "إنشاء تعميم",
    titleLabel: "العنوان",
    bodyLabel: "المحتوى (يدعم HTML)",
    audience: "الجمهور",
    guardians: "أولياء الأمور",
    teachers: "المعلمون",
    alsoEmail: "إرسال بالبريد الإلكتروني أيضاً",
    publishing: "جارٍ النشر...",
    publishNotify: "نشر وإشعار",
    publishedOn: "نُشر في {date}",
    sentCount: "أُرسل إلى {count}",
    readCount: "قرأه {count}",
    emptyState: "لا توجد تعاميم بعد. أنشئ أول تعميم.",
      emptyEmergencyState: "لا توجد إعلانات طوارئ بعد. أنشئ أول إعلان.",
    publishedToast: "تم نشر التعميم",
  },
  nursery: {
    pageTitle: "رياض الأطفال / EYFS",
    pageSubtitle: "ملاحظات الطفولة المبكرة، الصور والفيديو، انتهاء صلاحية المستندات",
    tabEyfs: "ملاحظات EYFS",
    tabGallery: "صور وفيديو",
    tabDocs: "انتهاء صلاحية المستندات",
    recentObservations: "أحدث الملاحظات ({count})",
    newObservation: "ملاحظة جديدة",
    logObservation: "تسجيل ملاحظة EYFS",
    selectChild: "اختر طفلاً",
    area: "المجال",
    assessment: "التقييم",
    milestonePlaceholder: "إنجاز (مثال: يتعرّف على الأرقام 1-10)",
    observationPlaceholder: "ما الذي لاحظته؟ (ظاهر اليوم، في أفعال الطفل نفسه)",
    save: "حفظ",
    observationLoggedToast: "تم تسجيل الملاحظة",
    downloadTermlyReport: "تنزيل تقرير التقدم الفصلي",
    reportDownloadedToast: "تم تنزيل تقرير التقدم الفصلي",
    reportDownloadError: "تعذر تنزيل تقرير التقدم الفصلي",
    albumsCount: "الألبومات ({count})",
    newAlbum: "ألبوم جديد",
    createAlbum: "إنشاء ألبوم",
    description: "الوصف",
    create: "إنشاء",
    albumCreatedToast: "تم إنشاء الألبوم",
    mediaCount: "{count} وسائط",
    expired: "منتهية",
    d30: "≤ 30 يوماً",
    d60: "31 – 60 يوماً",
    d90: "61 – 90 يوماً",
    expiring90Title: "مستندات تنتهي خلال الـ 90 يوماً القادمة",
    thDate: "التاريخ",
    thChild: "الطفل",
    thArea: "المجال",
    thMilestone: "الإنجاز",
    thAssessment: "التقييم",
    thNote: "الملاحظة",
    thBucket: "الفئة",
    thPerson: "الشخص",
    thType: "النوع",
    thKind: "الصنف",
    thNumber: "الرقم",
    thExpires: "ينتهي",
    levelEmerging: "ناشئ",
    levelDeveloping: "متطور",
    levelSecure: "متمكن",
    levelExceeding: "متجاوز",
    noObservationsYet: "لا توجد ملاحظات بعد. انقر «ملاحظة جديدة» لتسجيل الأولى.",
    noAlbumsYet: "لا توجد ألبومات بعد. يمكن للمعلمين رفع الصور هنا (بموافقة ولي الأمر).",
    noDocsExpiring: "لا توجد مستندات تنتهي قريباً. تُرسل رسالة أسبوعية للمديرين عند ظهور أي منها.",
  },
  feePlan: {
    chargeWhenBought: "يُحصَّل عند الشراء",
    chargeWhenBoughtHint: "لا يُستحق على كل الطلاب؛ يُحصَّل عند الصندوق متى اشتراه الطالب.",
    monthlyDueDay: "يوم استحقاق الرسوم الشهرية",
    monthlyDueDayHint: "تستحق بنود الرسوم الشهرية في هذا اليوم من كل شهر من أشهر الفصل (1–28). أشهر الإجازة بدون رسوم.",
    monthlyFeesDueTitle: "الرسوم الشهرية: يوم الاستحقاق",
    perMonth: "شهرياً",
    otherCharges: "رسوم أخرى",
    arabicName: "الاسم بالعربية",
    term: "الفصل",
    custom: "مخصص",
    standard: "قياسي",
    oneTime: "لمرة واحدة",
    amount: "المبلغ",
    type: "النوع",
    feeHead: "بند الرسوم",
    student: "الطالب",
    allowCustom: "السماح بمبلغ مخصص",
    allowCustomHint: "يمكن تحديد مبلغ خاص بالطالب لهذا الرسم.",
    optionalHint: "تُحصَّل الرسوم الاختيارية فقط من الطلاب المفعَّلة لهم.",
    customMin: "الحد الأدنى (٪ من القياسي)",
    customMax: "الحد الأقصى (٪ من القياسي)",
    noLimit: "بلا حد",
    termCalendar: "تقويم الفصول",
    termCalendarHint: "اختر أشهر كل فصل وكل إجازة. يمكن أن يتبع الشهر فترة واحدة فقط. يُدخل مرة واحدة لكل سنة دراسية.",
    termFeesDueTitle: "رسوم الفصل: مواعيد استحقاق الأقساط",
    termFeesDueHint: "لبنود الرسوم المحتسبة لكل فصل، وتُدفع على قسط واحد أو قسطين.",
    monthTakenBy: "مضاف بالفعل إلى {period}",
    pickDate: "اختر تاريخًا",
    clearDate: "مسح التاريخ",
    calendarNotSet: "غير محدد",
    calendarSaved: "تم حفظ تقويم الفصول",
    saveCalendar: "حفظ التقويم",
    installmentDue: "استحقاق القسط {n}",
    vacationLabel: "اسم الإجازة",
    notBilled: "بدون رسوم",
    addVacation: "إضافة إجازة",
    remove: "إزالة",
    feePlan: "خطة الرسوم",
    noStructure: "لا يوجد هيكل رسوم منشور لصف هذا الطالب وسنته الدراسية.",
    optionalEnabled: "اختياري · مفعَّل",
    optionalOff: "اختياري · غير مفعَّل",
    customise: "تخصيص",
    customiseTitle: "تخصيص {name}",
    appliesToStudent: "ينطبق على هذا الطالب",
    effectiveFrom: "يبدأ من",
    standardAmount: "القياسي {amount}",
    allowedRange: "المسموح {min} – {max}",
    coveredMonths: "الأشهر المشمولة (يقترح مبلغاً نسبياً)",
    reason: "السبب",
    selectReason: "اختر سبباً",
    note: "ملاحظة",
    blankKeepsStandard: "اترك المبلغ فارغاً للإبقاء على المبلغ القياسي.",
    planSaved: "تم تحديث خطة الرسوم",
    termBalance: "رصيد الفصول",
    asOf: "حتى {date}",
    expected: "المتوقع",
    discount: "الخصم",
    paid: "المدفوع",
    balance: "الرصيد",
    position: "الحالة",
    previousBalance: "الرصيد السابق",
    dueNow: "المستحق الآن",
    totalDue: "إجمالي المستحق",
    upcoming: "القادم",
    overdueSince: "متأخر منذ {date}",
    dueOn: "يستحق في {date}",
    settled: "مدفوع",
    calendarMissing: "حدِّد تقويم الفصول في الإعداد الأكاديمي لمتابعة أرصدة الفصول.",
    noDues: "لا توجد مستحقات مسجلة لهذه السنة.",
    notEnabledForStudent: "{name} رسم اختياري وغير مفعَّل لهذا الطالب. فعِّله من خطة رسوم الطالب.",
    alreadyCharged: "تم تحصيله",
    chargedLocked: "تم تحصيله بالفعل. ألغِ تلك الفاتورة لتغيير المبلغ.",
    overdueOnly: "المتأخرات فقط",
    exportXlsx: "تصدير XLSX",
    buildDues: "إنشاء / تحديث المستحقات",
    duesPreview: "{students} طالب · {plans} خطة رسوم جديدة · {created} مستحقات للإضافة · {updated} للتحديث · {voided} للإزالة",
    duesUnmatched: "{count} رسوم حالية لا تطابق أي مستحق متوقع وتحتاج إلى مراجعة:",
    applyDues: "تطبيق",
    duesApplied: "تم تحديث المستحقات",
  },
  customFee: {
    monthlyFees: "الرسوم الشهرية",
    pickMonths: "اختر الأشهر المدفوعة",
    custom: "مبلغ مخصص…",
    suggested: "المقترح {amount}",
    saveToPlan: "حفظ في خطة رسوم هذا الطالب",
    itemsBought: "الأصناف المشتراة",
    pickSizeFirst: "اختر مقاس الزي لاختيار الأصناف.",
    noItems: "لا توجد أصناف في المخزون لهذا المقاس.",
    qty: "الكمية",
    report: "الرسوم المخصصة",
    covers: "يغطي",
    charged: "المُحصَّل",
    difference: "الفرق",
    enteredBy: "أدخله",
    invoice: "الفاتورة",
    noCustomFees: "لا توجد رسوم مخصصة محصّلة لهذه السنة.",
  },
  finance: {
    feeHeads: "بنود الرسوم",
    grade: "الصف",
    feeStructures: "هياكل الرسوم",
    invoicesSubtitle: "الفواتير والدفع وهياكل الرسوم",
    discounts: "الخصومات",
    invoices: "الفواتير",
    refunds: "الاستردادات",
    reports: "التقارير",
    reportsDescription: "تصدير ملفات XLSX للإدارة والمالية والقبول بنقرة واحدة",
    download: "تنزيل",
    downloaded: "تم التنزيل",
    downloadFailed: "تعذر التنزيل",
    generalLedger: "دفتر الأستاذ العام",
    chartAccounts: "دليل الحسابات",
    trialBalance: "ميزان المراجعة",
    journal: "دفتر اليومية",
    collection: "التحصيل",
    collectionToday: "التحصيل ({date})",
    today: "اليوم",
    mtd: "منذ بداية الشهر",
    byMethodToday: "حسب الطريقة (اليوم)",
    byMethod: "حسب الطريقة",
    monthlyCollection: "التحصيل الشهري",
    monthTotal: "إجمالي الشهر",
    outstanding: "المستحقات",
    overdue: "المتأخرات",
    acrossPastDueInvoices: "عبر {count} من الفواتير المتأخرة",
    acrossInvoices: "عبر {count} من الفواتير",
    code: "الرمز",
    account: "الحساب",
    type: "النوع",
    debit: "مدين",
    credit: "دائن",
    total: "الإجمالي",
    amount: "المبلغ",
    gst: "ضريبة القيمة المضافة ٪",
    balance: "الرصيد",
    date: "التاريخ",
    narration: "البيان",
    reference: "المرجع",
    lines: "الأسطر",
    name: "الاسم",
    status: "الحالة",
    action: "الإجراء",
    method: "الطريقة",
    currency: "العملة",
    payment: "الدفع",
    and: "و",
    paid: "مدفوعة",
    issued: "صادرة",
    partiallyPaid: "مدفوعة جزئياً",
    cancelled: "ملغاة",
    online: "عبر الإنترنت",
    cash: "نقداً",
    bankTransfer: "تحويل مصرفي",
    pos: "نقطة بيع",
    cheque: "شيك",
    neft: "NEFT",
    balanced: "متوازن",
    notBalanced: "غير متوازن",
    asset: "أصل",
    expense: "مصروف",
    liability: "التزام",
    income: "دخل",
    equity: "حقوق الملكية",
    newJournalEntry: "قيد يومية جديد",
    postEntry: "ترحيل القيد",
    journalPosted: "تم ترحيل قيد اليومية",
    debitPaise: "مدين (بالبايس)",
    creditPaise: "دائن (بالبايس)",
    debitShort: "مدين",
    creditShort: "دائن",
    addLine: "إضافة سطر",
    noJournalEntries: "لا توجد قيود يومية بعد.",
    noRefunds: "لا توجد استردادات مسجلة.",
    noData: "لا تتوفر بيانات.",
    downloadReport: "تنزيل التقرير",
    recordRefund: "تسجيل استرداد",
    refundAndCancel: "استرداد وإلغاء",
    refundAndCancelInvoice: "استرداد وإلغاء الفاتورة",
    refundAndCancelExplainer: "سيتم استرداد كامل المبلغ المدفوع وإلغاء الفاتورة مع الاحتفاظ بسجل الاسترداد والإلغاء.",
    refundAndCancelled: "تم استرداد الفاتورة وإلغاؤها",
    fullRefundRequired: "يجب استرداد كامل المبلغ المدفوع لإلغاء هذه الفاتورة.",
    invoiceLevelRefund: "استرداد على مستوى الفاتورة",
    invoiceLevelRefundHint: "استخدم إجمالي الفاتورة عندما لا تحتوي الفاتورة القديمة على توزيع للدفع على بنود الرسوم.",
    applyVat: "تطبيق ضريبة القيمة المضافة",
    vatApplied: "تم تطبيق ضريبة القيمة المضافة",
    refundRecorded: "تم تسجيل الاسترداد",
    loading: "جارٍ التحميل…",
    loadError: "تعذر تحميل بيانات المالية.",
    paymentCount: "{count} دفعة",
    totalDebit: "إجمالي المدين",
    totalCredit: "إجمالي الدائن",
    notBalancedShort: "غير متوازن",
    accountCount: "دليل الحسابات ({count})",
    invoiceNumber: "رقم الفاتورة",
    student: "الطالب",
    period: "الفترة",
    allStatuses: "جميع الحالات",
    unpaid: "غير مدفوعة",
    pdf: "PDF",
    recordPayment: "تسجيل الدفع",
    academicYear: "السنة الأكاديمية",
    periodLabel: "اسم الفترة",
    generate: "إنشاء",
    generateInvoices: "إنشاء الفواتير",
    generating: "جارٍ الإنشاء...",
      selectStudent: "اختر الطالب",
      searchStudent: "ابحث بالاسم أو رقم القبول",
      noStudentsFound: "لم يتم العثور على طلاب",
      required: "مطلوب",
      amount: "المبلغ",
      issueDate: "تاريخ الإصدار",
      dueDate: "تاريخ الاستحقاق",
      invoiceTotal: "إجمالي الفاتورة",
    feeBreakdown: "تفاصيل الرسوم",
    noFeesSelected: "لم يتم تحديد أي رسوم",
    tuitionOnly: "الرسوم الدراسية فقط",
      notes: "ملاحظات",
    paymentReference: "المرجع / رقم الشيك / مرجع البنك",
    recording: "جارٍ التسجيل...",
    saving: "جارٍ الحفظ...",
    paymentRecorded: "تم تسجيل الدفع",
    upi: "UPI",
    card: "بطاقة",
    invoicesGenerated: "تم إنشاء {count} فاتورة",
    feeHead: "بند الرسوم",
    addFeeHead: "إضافة بند رسوم",
    publishedStructures: "هياكل الرسوم المنشورة",
    addStructure: "إضافة هيكل",
    active: "نشط",
    inactive: "غير نشط",
    structureActivated: "تم تفعيل الهيكل",
    structureDeactivated: "تم إلغاء تفعيل الهيكل",
    recurring: "متكرر",
    optional: "اختياري",
    gstRate: "معدل ضريبة القيمة المضافة (نقاط الأساس)",
    gstHint: "500 نقطة أساس = 5٪ ضريبة قيمة مضافة",
    edit: "تعديل",
    yes: "نعم",
    no: "لا",
    noFeeHeads: "لم يتم إعداد بنود رسوم.",
    noFeeStructures: "لا توجد هياكل رسوم.",
    feeHeadCreated: "تم إنشاء بند الرسوم",
    feeHeadUpdated: "تم تحديث بند الرسوم",
    editFeeHead: "تعديل بند الرسوم",
    createFeeHead: "إنشاء بند رسوم",
    update: "تحديث",
    create: "إنشاء",
    save: "حفظ",
    structureName: "اسم الهيكل",
    lineItems: "بنود الرسوم",
    feeHeadPlaceholder: "بند الرسوم",
    selectGrade: "اختر الصف",
    allGrades: "جميع الصفوف",
    allAges: "جميع الأعمار",
    oneTime: "مرة واحدة",
    monthly: "شهري",
    term: "فصلي",
    annual: "سنوي",
    structureCreated: "تم إنشاء هيكل الرسوم",
    structureUpdated: "تم تحديث هيكل الرسوم",
    editStructure: "تعديل هيكل الرسوم",
    creating: "جارٍ الإنشاء...",
    updating: "جارٍ التحديث...",
    term1: "الفصل 1",
    term2: "الفصل 2",
    term3: "الفصل 3",
    installmentsPerTerm: "الأقساط لكل فصل",
    studentFeePayment: "دفع رسوم الطالب",
    studentFeePaymentDone: "تم تسجيل دفع الرسوم",
    admissionNumber: "رقم القبول",
    fullTerm: "الفصل كاملاً",
    installment: "قسط",
    feeSelection: "اختيار الرسوم",
    noFeeStructureForStudent: "لا يوجد هيكل رسوم منشور لهذا الطالب في السنة الدراسية المحددة.",
    otherFees: "رسوم أخرى",
    paymentMode: "طريقة الدفع",
    manualCash: "يدوي - نقدي",
    online: "عبر الإنترنت",
    pos: "نقطة البيع",
    utr: "مرجع UTR",
    utrPlaceholder: "مثال: UTR123456789",
    posReference: "مرجع نقطة البيع",
    posReferencePlaceholder: "مثال: POS123456789",
    paymentStatus: "حالة الدفع",
    recordAndGenerate: "تسجيل الدفع وإنشاء الفاتورة",
    siblingDiscount: "قواعد خصم الأشقاء",
    discountRules: "قواعد الخصم",
    editRules: "تعديل القواعد",
    secondChildDiscount: "خصم الطفل الثاني",
    twinDiscount: "خصم التوأم",
    scholarshipLevel1: "منحة المستوى الأول",
    scholarshipLevel2: "منحة المستوى الثاني",
    twinEligibility: "أهلية التوأم",
    markTwinEligible: "تحديد الطفل كمؤهل لخصم التوأم",
    selectStudent: "اختر الطفل",
    discountType: "نوع الخصم",
    selectDiscountType: "اختر نوع الخصم",
    applyDiscount: "تطبيق الخصم",
    discount: "الخصم",
    discountApplied: "تم تطبيق الخصم",
    discountEligibilityUpdated: "تم تحديث أهلية الخصم",
    customDiscounts: "الخصومات المخصصة",
    createCustomDiscount: "إنشاء خصم مخصص",
    customDiscountName: "اسم الخصم",
    percentage: "النسبة المئوية",
    fixedAmount: "مبلغ ثابت",
    customDiscountCreated: "تم إنشاء الخصم المخصص",
    customDiscountArchived: "تمت أرشفة الخصم المخصص",
    studentPaymentDiscounts: "الخصومات (اختياري)",
    noDiscountsAvailable: "لا توجد خصومات نشطة.",
    selectFeeBeforeDiscount: "حدد بند رسوم واحدًا على الأقل لتطبيق الخصم.",
    discountsLoading: "جارٍ تحميل الخصومات المتاحة…",
    discountsLoadError: "تعذر تحميل الخصومات. حاول مرة أخرى.",
    archive: "أرشفة",
    archived: "مؤرشف",
    discountTypes: { second_child: "خصم الطفل الثاني", twin: "خصم التوأم", scholarship_level_1: "منحة المستوى الأول", scholarship_level_2: "منحة المستوى الثاني" },
    enabled: "مفعّل",
    disabled: "معطّل",
    noRulesConfigured: "لم يتم إعداد القواعد. الافتراضي: 10٪ للطفل الثاني و50٪ للتوأم و33.33٪ و47.22٪ لمستويي المنحة.",
    rulesUpdated: "تم تحديث القواعد",
    saveRules: "حفظ القواعد",
    invoice: "الفاتورة",
    selectInvoice: "اختر الفاتورة",
    paidSuffix: "مدفوع",
    maxRefundable: "الحد الأقصى القابل للاسترداد",
    cardReversal: "عكس البطاقة",
    adjustment: "تسوية",
    reason: "السبب",
    refundReasonPlaceholder: "مثال: دفعة مكررة",
    periodPlaceholder: "مثال: الفصل الثاني",
    leaveGradesEmpty: "اترك الصفوف فارغة لتضمين جميع الصفوف ذات هياكل الرسوم المنشورة.",
    unpaidParenthetical: "غير مدفوعة",
    referencePlaceholder: "مثال: CHQ-000123 أو NEFT-UTR",
    tuitionPlaceholder: "مثال: الرسوم الدراسية",
    codePlaceholder: "مثال: TUIT",
    void: "إلغاء",
    voidInvoice: "إلغاء الفاتورة",
    voided: "تم إلغاء الفاتورة",
    voidExplainer: "يلغي الإلغاء فاتورة غير مدفوعة أو تم استردادها بالكامل. يتم تصفير الرصيد مع الاحتفاظ بكل السجل. الفواتير التي لا تزال تحتفظ بدفعة يجب استردادها أولاً.",
    voidReasonPlaceholder: "مثال: فاتورة مكررة",
    payByLineHint: "أدخل مبلغًا لكل بند من بنود الرسوم. الإجمالي هو مجموع البنود.",
    refundByLineHint: "أدخل مبلغ الاسترداد لكل بند. الإجمالي هو مجموع البنود.",
    scheduled: "مجدولة",
    voidedStatus: "ملغاة",
    refunded: "مستردة",
    waived: "مُعفاة",
    issuedStatus: "صادرة",
    duplicateFee: "تم تحصيل هذه الرسوم مسبقًا عن هذه الفترة",
    allocationRequired: "حدد مبلغًا لكل بند من بنود الرسوم",
    invoiceNumberShort: "فاتورة",
    notRefundable: "بند الرسوم هذا غير قابل للاسترداد",
  },
  management: {
    studentsTitle: "الطلاب",
    studentsSubtitle: "دليل جميع الطلاب المسجلين",
    studentsSearch: "البحث بالاسم أو رقم القبول…",
    studentsNoResults: "لم يتم العثور على طلاب",
    staffTitle: "الموظفون",
    staffSubtitle: "المعلمون والمحاسبون والمديرون والإداريون وموظفو الاستقبال ومُلّاك المستأجرين",
    inviteStaff: "دعوة موظف",
    servicesTitle: "خدمات الطلاب",
    servicesSubtitle: "النقل والصحة والوجبات والفعاليات والسكن",
    announcementsTitle: "الإعلانات",
    announcementsSubtitle: "إدارة الفعاليات والتعاميم وإعلانات الطوارئ",
    libraryTitle: "المكتبة",
    librarySubtitle: "فهرس الكتب وتتبع الإعارة",
    analyticsTitle: "الرؤى",
    analyticsSubtitle: "مؤشرات مباشرة + مخاطر التسرب المتوقعة (الحضور × الرسوم × الانضباط)",
    admissionsTitle: "القبول",
    admissionsSubtitle: "مراجعة الطلبات وإدارة التسجيل",
    attendanceTitle: "الحضور",
    attendanceSubtitle: "مراقبة الحضور اليومي عبر الأقسام",
    timetableTitle: "الجدول الدراسي",
    examsTitle: "الاختبارات",
    campusTitle: "عمليات الحرم المدرسي",
    campusSubtitle: "السلامة والانضباط والخريجون والتوظيف وخدمات السكن",
    institutionTitle: "المؤسسة",
    institutionSubtitle: "الملف الأساسي ومعلومات الاتصال",
    dcumentsTitle: "المستندات",
    dcumentsSubtitle: "البحث في المستندات المرفوعة عبر الموظفين والقبول والمؤسسة",
    searchDocumentsOption: "بحث المستندات",
    documentsExpiryOption: "انتهاء البيانات",
    documentsSearchLabel: "بحث",
    documentsSearchPlaceholder: "ابحث بالاسم أو النوع أو الرقم أو رقم الطلب…",
    documentsSearchSource: "المصدر",
    documentsSearchButton: "بحث المستندات",
    documentsSearchNoResults: "لم يتم العثور على مستندات",
    inspectionTab: "مستندات التفتيش",
    inspectionTitle: "مستندات التفتيش",
    inspectionSubtitle: "احتفظ بسجلات الترخيص والإيجار والسلامة والسجلات التنظيمية للحضانة جاهزة للتفتيش.",
    inspectionAdd: "إضافة مستند",
    inspectionEdit: "تعديل المستند",
    inspectionDialogDescription: "سجّل تفاصيل المستند وأرفق أحدث ملف. يستخدم شيك الإيجار حقل الانتهاء كتاريخ استحقاق.",
    inspectionType: "نوع المستند",
    inspectionSelectType: "اختر نوع المستند",
    inspectionFile: "ملف المستند",
    inspectionReplacementFile: "ملف بديل (اختياري)",
    inspectionNumber: "رقم المستند",
    inspectionChequeNumber: "رقم الشيك",
    inspectionIssueDate: "تاريخ الإصدار",
    inspectionExpiryDate: "تاريخ الانتهاء",
    inspectionChequeDueDate: "تاريخ استحقاق الشيك",
    inspectionExpiryOrDue: "تاريخ الانتهاء / الاستحقاق",
    inspectionNotes: "ملاحظات",
    inspectionStatus: "الحالة",
    inspectionFiles: "الملفات",
    inspectionActions: "الإجراءات",
    inspectionCurrent: "ساري",
    inspectionNoDate: "بلا تاريخ",
    inspectionReminderNote: "تظهر تنبيهات الانتهاء واستحقاق الشيك داخل EduOS قبل 30 و60 و90 يوماً. لا تُرسل رسائل خارجية.",
    inspectionNoInstitution: "لا توجد مؤسسة مرتبطة بهذا الحساب.",
    inspectionNoTypes: "لم يتم إعداد أنواع مستندات المؤسسة في إعدادات المنصة.",
    inspectionEmptyTitle: "لا توجد مستندات تفتيش بعد",
    inspectionEmptyBody: "أضف أول سجل تفتيش أو إيجار للحضانة.",
    inspectionLoadError: "تعذر تحميل مستندات التفتيش.",
    inspectionCreated: "تمت إضافة مستند التفتيش",
    inspectionUpdated: "تم تحديث مستند التفتيش",
    inspectionDeleted: "تم حذف مستند التفتيش",
    inspectionExpiryRequired: "تاريخ الانتهاء مطلوب لهذا النوع من المستندات.",
    inspectionChequeDateRequired: "تاريخ استحقاق الشيك مطلوب.",
    documentsSourceAll: "الكل",
    documentsSourceStaff: "الموظفون",
    documentsSourceAdmission: "القبول",
    documentsSourceInstitution: "المؤسسة",
    documentsSource: "المصدر",
    documentsName: "الاسم",
    documentsType: "النوع",
    documentsNumber: "الرقم",
    documentsExpiry: "الانتهاء",
    documentsReference: "المرجع",
    documentsFiles: "الملفات",
    documentsRoleFather: "الأب",
    documentsRoleMother: "الأم",
    documentsRoleChild: "الطفل",
  },
  academic: {
    title: "الإعداد الأكاديمي",
    subtitle: "إدارة المستويات والفصول والمواد",
    gradesTab: "الصفوف",
    agesTab: "الفئات العمرية",
    sectionsTab: "الفصول",
    subjectsTab: "المواد",
    yearsTab: "السنوات الدراسية",
    levelSystem: "نظام المستويات",
    gradeModeDesc: "تُسمى المستويات بالصفوف (الصف الأول، الصف الخامس …).",
    ageModeDesc: "تُسمى المستويات حسب عمر الطفل (٤٥ يوماً – سنة، سنة – سنتان …).",
    switchToAges: "التبديل إلى الفئات العمرية",
    switchToGrades: "التبديل إلى الصفوف",
    switchToAgesTitle: "تبديل هذا الفرع إلى الفئات العمرية",
    switchToAgesDesc: "اختر الفئة العمرية لكل مستوى. المستويات ذات الفئة نفسها تندمج في فئة عمرية واحدة — تُخفى أسماء الصفوف في كل مكان وتعود عند التبديل إلى الصفوف.",
    switchToGradesTitle: "إعادة هذا الفرع إلى الصفوف",
    switchToGradesDesc: "تنقسم كل فئة عمرية إلى صفوفها الأصلية — تعود الفصول والرسوم والأسماء كما كانت تماماً.",
    switchToGradesHint: "يستعيد كل صف مدموج اسمه وفصوله وهياكل رسومه الأصلية. أكّد للمتابعة.",
    editMapping: "تعديل ربط الفئات العمرية",
    editMappingTitle: "تعديل ربط الفئات العمرية",
    editMappingDesc: "غيّر الفئة العمرية التي ينتمي إليها كل مستوى. يجب أن يكون لكل مستوى فئة.",
    unmappedHint: "هناك {count} مستويات بلا فئة عمرية بعد. اختر فئة لكل مستوى للمتابعة.",
    noLevelsYet: "لا توجد مستويات بعد. أضف فئات عمرية أولاً أو عد إلى الصفوف.",
    keepAsIs: "إبقاء كما هو",
    duplicateBandWarning: "تم ربط مستويين أو أكثر بنفس الفئة العمرية. هذا مسموح — سيعرض كل مستوى اسم الفئة.",
    sharedBandNote: "{count} مستويات تشترك في هذه الفئة العمرية. مسموح — يحتفظ كل مستوى بفصوله ورسومه.",
    confirmSwitch: "تأكيد التبديل",
    switching: "جارٍ التبديل…",
    switchDone: "تم تحديث نظام المستويات",
    addGrade: "إضافة صف",
    addBand: "إضافة فئة عمرية",
    chooseBand: "اختر الفئة العمرية",
    gradeAdded: "تمت إضافة الصف",
    bandAdded: "تمت إضافة الفئة العمرية",
    displayOrder: "ترتيب العرض",
    namePlaceholder: "الاسم (مثال: الصف التاسع)",
    deleteLevel: "حذف المستوى",
    levelDeleted: "تم حذف المستوى",
    outsideAllBands: "عمر هذا الطفل خارج الفئات العمرية المحددة. يمكنك المتابعة.",
  },
};

export default ar;
